import React, { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import PlaceholderPaper, { IPlaceholderPaperProps } from "./PlaceholderPaper";
import DialogTransition from "../DialogTransition";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            color: theme.palette.common.black,
        },
    });
});

export interface IStyledDialogProps extends DialogProps {
    onClose: () => void;
    title?: string;
    children?: ReactNode;
}

export default function StyledDialog(props: IStyledDialogProps) {
    const classes = useStyles();
    const { onClose, title, children, className, ...rest } = props;

    const paperProps: IPlaceholderPaperProps = {
        title,
        onClose,
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            className={clsx(className, classes.root)}
            TransitionComponent={DialogTransition}
            keepMounted
            onClose={handleClose}
            PaperComponent={PlaceholderPaper}
            PaperProps={paperProps}
            {...rest}
        >
            {children}
        </Dialog>
    );
}
